import { ProjectData, Tags, Languages, Software, ProjectStatus, Products, Contributors, OtherLanguages } from '@structures/ProjectData';
import { Downloads } from '@projects/Dino Quest';
import { FileType } from '@models';

export const DownloadAssets = Object.values(Downloads);

export const DinoQuest: ProjectData = {
    summary: {
        id: "DQ",
        title: "Dino Epoch",
        aliases: ["Dino Epoch", "DE", "DQ", "Zelda Clone"],
        filter: { settings: { pixelSize: 1 }},
        version: 1.00,
        status: ProjectStatus.Completed,
        initial: new Date(2025, 5, 6),
        release: new Date(2025, 5, 8),
        previews:[{
            file: new URL("https://raw.githubusercontent.com/MakoInfused/Dino_Epoch/main/promo/images/new_game.png"),
            type: FileType.Image,
            description: "An image of a NES 8-bit retro Action RPG gameplay image.",
            caption: `The gameplay of the first screen in the game.`
        }],
        tags: {
            [Tags.Products]: [
                Products.Games
            ],
            [Tags.Software]: [
                Software.VSC
            ],
            [Tags.Languages]: [
                Languages.C,
                OtherLanguages.NES
            ]
        },
        description: "A quickly made Action RPG NES game, inspired by Legend of Zelda."
    },
    details: {
        description: "A simple & fun Action RPG that lets you play as ... me!"
            + "<br/><br/>"
            + "A dream of mine as a kid was to create something like this, I'm proud of myself."
            + "<br/><br/>"
            + "Created the entire game in 3 days & it works on the real hardware!"
            + "<br/><br/>"
            + "It's a wonder what modern tooling can help you create!"
            + "<br/><br/>"
            + `Want to see how it's made, check it out <a href="https://github.com/MakoInfused/Dino_Epoch">here on my github</a>.`,
        gallery: [{
                    file: DownloadAssets[0],
                    type: FileType.Download,
                    description: `<button class="rpgui-button">Download</button>`,
                    caption: "First official release of the game."
            }],
        contributions: [{
            contributor: Contributors.MakoInfused,
            roles: [{
                title: "Gameplay Engineer",
                involvement: "Developed most of the game systems logic and flow, along with structures to support its data.",
                achievements: [
                    "Coded the object system and incorporated heroes, enemies, npc's, bosses, items, and more.",
                    "Developed the battle system: including sword and shield as well as simple monster AI patterns.",
                    "Added a simple sprite loading system and integrated it into a Tiled based map editor.",
                    "Wrote a lot of low level 6502 assembly code to support the banking strategy used by the game to store extra data."
                ]
            }, {
                title: "Game Designer",
                involvement: "Ideated how the game will work, created a project outline.",
                achievements: [
                    "Wrote the storyline, characters.",
                    "Designed the puzzles and how to solve the game by gathering the required items."
                ]
            }]
        }]
    },
};

export default DinoQuest;